import { render, staticRenderFns } from "./AdvCartGiftRow.vue?vue&type=template&id=31770d28"
import script from "./AdvCartGiftRow.vue?vue&type=script&lang=js"
export * from "./AdvCartGiftRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports